import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';

export const metaPixelEvents = {
    VIEW_CONTENT: 'ViewContent',
    INITIATE_CHECKOUT: 'InitiateCheckout',
}

export const trackMetaEvent = (event, data = {}) => {
    if (process.env.REACT_APP_ENV !== 'prod') return;
    ReactPixel.track(event, data);
}

export const MetaPixelPageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (process.env.REACT_APP_ENV !== 'prod') return;
        ReactPixel.pageView();
    }, [location]);

    return null;
}
